import React, { useState } from 'react';
import classnames from 'classnames';

import './LoadingSpinner.scss';
import { useMount } from 'react-use';

export enum LoadingSpinnerSizeModifiers {
  small = 'sm',
}

export interface LoadingSpinnerProps {
  size?: LoadingSpinnerSizeModifiers;
  label?: string;
  delayed?: boolean | number;
}

const DEFAULT_SPINNER_DELAY = 500;

const LoadingSpinner = ({
  size = LoadingSpinnerSizeModifiers.small,
  label = 'Loading...',
  delayed,
}: LoadingSpinnerProps) => {
  const [visible, setVisible] = useState(!delayed);
  useMount(() => {
    const delay =
      typeof delayed === 'boolean' ? DEFAULT_SPINNER_DELAY : delayed;
    const timeoutId = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(timeoutId);
  });

  return visible ? (
    <div className={classnames('loader', size)}>{label}</div>
  ) : null;
};

export { LoadingSpinner };
